import { Pipe, PipeTransform } from '@angular/core';
import { getMoment } from '../services/datetime.service';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'datePresentation',
})
export class DatePresentationPipe implements PipeTransform {
  constructor() {}
  public transform(value: string, args?: any): string {
    if (value === '0001-01-01T00:00:00+00:00' || value === '1900-01-01T00:00:00+00:00' || value === '-') {
      return '-';
    }
    const format = args === 'hms' ? `${environment.dateFormatHms}` : `${environment.dateFormatSystem}`;
    const message = getMoment(value, format).format(
      args === 'hms' ? environment.dateFormatHmsPresentation : environment.dateFormatPresentation,
    );
    return message;
  }
}
